module.exports = __webpack_public_path__ + "img/cushion.3e6a6f47.png";